import { useState } from "react";
import { FaArrowRight, FaArrowLeft } from "react-icons/fa";
import { FaArrowRightLong } from "react-icons/fa6";
import Portfolio_shadow from "../../common/images/Portfolio-shadow.png";

import Portfolio from "../../common/images/portfolio-1.png";
import Portfolio2 from "../../common/images/portfolio-2.png";
import Portfolio3 from "../../common/images/portfolio-3.png";

import Portfolio4 from "../../common/images/portfolio-4.png";

import Portfolio5 from "../../common/images/portfolio-5.png";

const projects = [
  {
    id: 1,
    title_2: "SMART",
    title: " PARKING DEALS",
    description:
      "We developed Smart Parking Deals, a website that helps users compare and book affordable airport parking options easily. It offers real-time availability, pricing, and secure booking for a seamless experience.",
    image: Portfolio,
    link: "https://www.smartparkingdeals.co.uk/",
  },
  {
    id: 2,
    title_2: "AYGO",

    title: " AIRPORT PARKING ",
    description:
      "We developed a seamless airport parking solution with AYGO, offering secure and convenient parking options. This service ensures hassle-free parking and quick terminal access for travelers.",
    image: Portfolio2,
    link: "",
  },
  {
    id: 3,
    title_2: "COMPARE ",

    title: "AIRPORT PARKING",
    description:
      "We developed a comprehensive airport parking comparison tool, allowing users to easily compare parking options. The tool helps travelers find the most convenient and cost-effective parking solutions at the airport.. The tool helps travelers find the most convenient and cost-effective parking solutions at the airport.",
    image: Portfolio3,
    link: "https://www.compareairportparkingdeals.co.uk/search.php",
  },
  {
    id: 4,
    title_2: "ITALIAN ",

    title: " PIZZA ",
    description:
      "We developed an Italian pizza ordering platform, offering a wide selection of authentic Italian pizzas. The platform provides a seamless and user-friendly experience for pizza lovers to enjoy traditional flavors at their fingertips.",
    image: Portfolio4,
    link: "https://www.italianpizzas.co.uk/",
  },
  {
    id: 5,
    title_2: "CHIKITOS ",

    title: "PERI PERI ",
    description:
      "We developed a platform for Chikitos, specializing in Peri Peri pizza, offering a unique and spicy twist on traditional pizza. The platform provides a seamless ordering experience for customers to enjoy bold, flavorful pizzas with a kick",
    image: Portfolio5,
    link: "https://www.chikitosperiperi.co.uk/",
  },
];

export default function PortfolioShowcase() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const handleNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === projects.length - 1 ? 0 : prevIndex + 1
    );
  };

  const handlePrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? projects.length - 1 : prevIndex - 1
    );
  };

  return (
    <div className="bg-gradient-to-b from-blue-100 to-white">
      <section className="max-w-[1280px] mx-auto md:px-10 px-5 py-10 relative">
        <div className="absolute bottom-0 right-0  ">
          {" "}
          <img
            src={Portfolio_shadow}
            alt="Portfolio_shadow"
            className="w-[50%] ml-auto"
            srcset=""
          />
        </div>
        <div className="text-center">
          <h2 className="small:text-4xl text-3xl font-bold md:text-5xl">
            Portfolio Showcase{" "}
          </h2>{" "}
          <div className="underline w-1/5 flex justify-center mx-auto my-4 items-center h-[2px] rounded-md bg-primary">
            <p className="h-[5px] rounded-xl bg-yellow-400 w-[50%]"></p>
          </div>
          <p className=" font-semibold md:max-w-3xl max-w-5xl mx-auto">
            Explore our latest projects and see how we've helped businesses grow
            through creative and functional web solutions
          </p>{" "}
        </div>

        {/* Project Container */}
        <div className="relative flex flex-col lg:flex-row items-center md:mt-10 mt-0 py-10">
          {/* Navigation Buttons */}
          <button
            className="absolute  bottom-0 md:left-[45%] left-[30%] transform translate-y-1/2 bg-yellow-500 p-3 rounded-full shadow-lg hover:bg-yellow-600 transition"
            onClick={handlePrev}
          >
            <FaArrowLeft className="text-white text-lg" />
          </button>
          <button
            className="absolute left-[50%] bottom-0 transform translate-y-1/2 bg-yellow-500 p-3 rounded-full shadow-lg hover:bg-yellow-600 transition"
            onClick={handleNext}
          >
            <FaArrowRight className="text-white text-lg" />
          </button>

          {/* Project Image */}
          <div className="w-full lg:w-1/2 flex justify-center">
            <img
              src={projects[currentIndex].image}
              alt="Project"
              className="w-full"
            />
          </div>

          {/* Project Info */}
          <div className="w-full lg:w-1/2 text-center lg:text-left mt-6 lg:mt-0">
            <div className="md:text-5xl small:text-3xl text-end  font-bold ">
              <h2 className="value-yellow md:text-5xl small:text-4xl text-[1.875rem]">
                {projects[currentIndex].title_2}
              </h2>
              <span className="text-[#0965AC]  md:text-5xl small:text-4xl text-3xl">
                {projects[currentIndex].title}
              </span>
              <div className="underline w-2/5 flex justify-end ml-auto my-4 items-center h-[3px] rounded-md bg-[#0965AC]">
                <p className="size-3 shadow-md rounded-full bg-[#0965AC] "></p>
              </div>
            </div>
            <p className="text-gray-600 mt-3">
              {projects[currentIndex].description}
            </p>

            <a
              href={projects[currentIndex].link}
              className="inline-flex items-center bg-secondary text-white px-4 py-2 mt-4 rounded-full shadow-md hover:bg-blue-800 transition"
            >
              View Website{" "}
              <FaArrowRightLong className="ml-2 bg-white rounded-full text-webOranage p-1 text-3xl -rotate-45" />
            </a>
          </div>

          {/* Navigation Buttons */}
        </div>
      </section>
    </div>
  );
}
